import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "app/guards";
import { ProfileProvider } from "app/contexts/profile";
import { ResourcesProvider } from "app/contexts/resources";
import { MainLayout } from "./main-layout";
import { DashboardRoutes } from "./dashboard-routes";
import { AdminRoutes } from "./admin-routes";
import { EmpresasRoutes } from "./empresas-routes";
import { SolicitudesRoutes } from "./solicitudes-routes";
import { ProfileRoutes } from "./profile-routes";

export function MainRoutes() {
  return (
    <AuthGuard>
      <ProfileProvider>
        <ResourcesProvider>
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Navigate to="empresas" replace />} />

              {/* <Route path="dashboard/*" element={<DashboardRoutes />} /> */}
              <Route path="empresas/*" element={<EmpresasRoutes />} />
              {/* <Route path="solicitudes/*" element={<SolicitudesRoutes />} /> */}
              {/* <Route path="admin/*" element={<AdminRoutes />} /> */}
              <Route path="profile/*" element={<ProfileRoutes />} />

              <Route path="*" element={<Navigate to="dashboard" />} />
            </Route>
          </Routes>
        </ResourcesProvider>
      </ProfileProvider>
    </AuthGuard>
  );
}
